import {put, takeEvery, select} from 'redux-saga/effects';
import {
  CALCULATE_ADJUST,
  CALCULATE_ADJUST_SUCCESS,
  CREATE_ADJUST,
  OPEN_ADJUST_ERROR_MODAL,
  OPEN_ADJUST_SUCCESS_MODAL
} from 'store/ordersV2/orderAdjust/action';
import {
  calculateOrderAdjust,
  createOrderAdjust
} from 'helpers/services/api/ordersV2';
import {GET_ORDER} from 'store/ordersV2/orderDetails/action';
import generateAdjustError from 'helpers/functionUtils/adjustHelper';
import {ORDER, ORDER_SOURCE} from 'helpers/constants/orders_v2';

function* calculateAdjust({payload: {data, orderId}}) {
  try {
    const locationId = yield select((state) => state.user.locationId);
    const {data: calculationResult} = yield calculateOrderAdjust(orderId, {
      ...data,
      locationId
    });
    if (calculationResult) {
      yield put(CALCULATE_ADJUST_SUCCESS(calculationResult));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}
function* createAdjust({payload: {data, invoiceId, orderId}}) {
  try {
    const locationId = yield select((state) => state.user.locationId);
    const order = yield select((state) => state.orderDetailsV2Reducer.order);
    const {
      data: {status, error}
    } = yield createOrderAdjust(orderId, {
      ...data,
      locationId
    });
    const isGrubHub = order?.[ORDER.SOURCE] === ORDER_SOURCE.GRUBHUB;
    const treatAsSuccess =
      !error &&
      (status === 'Succeeded' ||
        (isGrubHub && status !== 'Failed' && status !== 'Rejected'));
    if (treatAsSuccess) {
      yield put(OPEN_ADJUST_SUCCESS_MODAL(true));
      yield put(GET_ORDER(orderId));
    } else if (error && error.code) {
      yield put(
        OPEN_ADJUST_ERROR_MODAL({isOpen: true, ...generateAdjustError(error)})
      );
    }
  } catch (error) {
    if (error?.response?.data?.error) {
      yield put(
        OPEN_ADJUST_ERROR_MODAL({
          isOpen: true,
          ...generateAdjustError(error.response.data.error)
        })
      );
    } else {
      yield put(
        OPEN_ADJUST_ERROR_MODAL({
          isOpen: true,
          title: 'Something went wrong',
          message: null
        })
      );
    }
    console.log('SAGA ERROR', error);
  }
}

function* orderAdjustV2Saga() {
  yield takeEvery(CALCULATE_ADJUST, calculateAdjust);
  yield takeEvery(CREATE_ADJUST, createAdjust);
}

export default orderAdjustV2Saga;
